var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.type==0?'plat':'webdefault',attrs:{"id":"app"},on:{"click":_vm.setClock}},[_c('router-view'),_c('loginmask',{ref:"login"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }